const state = {
  waitingForConnection: false,
  online: false,
  isLoading: false,
  viewMap: true,
  appName: 'Omniscient',
  sidebarShown: true,
  isMobile: false,
}

const getters = {
  isLoading: (state) => state.isLoading,
  viewMap: (state) => state.viewMap,
  appName: (state) => state.appName,
  isSidebarShown: (state) => state.sidebarShown,
  isMobile: (state) => state.isMobile,
}

const mutations = {
  SET_LOADING: (state, isLoading) => {
    state.isLoading = isLoading
  },
  SET_ONLINE: (state) => {
    state.online = true
  },
  SET_OFFLINE: (state) => {
    state.online = false
  },
  SET_VIEW_MAP: (state, viewMap) => {
    state.viewMap = viewMap
  },
  SET_WAITING_FOR_CONNECTION: (state) => {
    state.waitingForConnection = true
  },
  SET_IS_MOBILE: (state, isMobile) => {
    state.isMobile = isMobile
  },
  UNSET_WAITING_FOR_CONNECTION: (state) => {
    state.waitingForConnection = false
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebarShown = !state.sidebarShown
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
